import React from 'react';
import classNames from 'classnames';
import style from './App.less';

import { injectIntl } from 'react-intl';
import { inject, toggleInject } from "../components/injector";


class Error5 extends React.PureComponent {
    componentDidMount(){
        document.title = this.props.intl.formatMessage({ id: 'faultTitle' })
    }
    strs = (id) => {
        const { formatMessage } = this.props.intl;
        const data = formatMessage({ id: id });
        return data.replace(/(\r\n)|(\n)/g, '<br/>');
    };

    render() {
        const { pwr, intl, history } = this.props;
        return (
            <div className={style.errorPage}>
                    <div className={style.errorTitle}>{intl.formatMessage({ id: 'error5Title' })}</div>
                    <div className={style.errorContent}>
                        <div className={style.errorDesc}>{intl.formatMessage({ id: 'error1desc' })}</div>
                        <table className={style.table5}>
                            <tbody>
                                <tr>
                                    <td>{intl.formatMessage({ id: 'errorReason' })}</td>
                                    <td>{intl.formatMessage({ id: 'resolvent' })}</td>
                                </tr>
                                <tr>
                                    <td>{intl.formatMessage({ id: 'error5A' })}</td>
                                    <td dangerouslySetInnerHTML={{ __html: this.strs('error5AMethod') }}></td>
                                </tr>
                                <tr>
                                    <td>{intl.formatMessage({ id: 'error5B' })}</td>
                                    <td dangerouslySetInnerHTML={{ __html: this.strs('error5BMethod') }}></td>
                                </tr>
                                <tr>
                                    <td>{intl.formatMessage({ id: 'error5C' })}</td>
                                    <td>{intl.formatMessage({ id: 'error5CMethod' })}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
        )
    }
}



export default inject()(injectIntl(Error5));